'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import CrewTouch from '../components/crew/Touch';
import Popin from '../components/crew/Popin'
import MoveFollow from '../components/MoveFollow'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--crew'
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        if(typeof this.slideshow != "undefined") {
            this.slideshow.destroy()
        }
        if(typeof this.movefollow != "undefined") {
            this.movefollow.destroy()
        }
        if(typeof this.popin != "undefined") {
            this.popin.destroy()
        }
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        // Fns
        setTimeout(() => {
            if(Env.desktop == false && Env.mobile == true && this.view.querySelector('.jsCrewTouch--view')) {
                this.popin = new Popin(this.view)
                this.popin.setup()
                this.slideshow = new CrewTouch(this.view.querySelector('.jsCrewTouch--view'))
                this.slideshow.setup()
            } else {
                this.movefollow = new MoveFollow(this.view.querySelector('.jsMove--view'))
                this.movefollow.setup()
            }
        }, 200);

        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 500);
    }

    intro()
    {
        const tl = new TimelineLite()
        const $mainVisual = this.view.querySelectorAll('.crew-cover .visual')
        const $itemsBg = this.view.querySelectorAll('.jsCrewTouch--view .bg')
        const $itemsInner = this.view.querySelectorAll('.jsItem .jsText')
        if(Env.desktop == false && Env.mobile == true)
        {
            tl.add([
                TweenMax.fromTo($mainVisual , 1 , { opacity : 0 } , { opacity : 1 , ease : Power4.easeOut }),
                TweenMax.staggerFromTo($itemsBg , 1 , { opacity : 0 } , { opacity : 1 , ease : Power4.easeOut },.05),
                TweenMax.staggerFromTo($itemsInner , .8 , { opacity : 0 , y : 50 } , { opacity : 1 , y : 0  , ease : Power4.easeOut , delay : .49 },.05),
            ])
        } else {
            tl.add([
                TweenMax.fromTo($mainVisual , 1 , { opacity : 0 } , { opacity : 1 , ease : Power4.easeOut }),
            ])
        }
        tl.add(()=>{
            TweenLite.set($itemsBg , { clearProps : "x" })
            TweenLite.set($itemsInner , { clearProps : "y" })
        })

    }
}

page = Barba.BaseView.extend({
    namespace: 'crew',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;


// WEBPACK FOOTER //
// ./resources/js/view/crew.js